var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:business-time",
    clipPath: "url(#clip0_1_12529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 3.75H20.5C20.775 3.75 21 4.03125 21 4.375V7.5H11V4.375C11 4.03125 11.225 3.75 11.5 3.75ZM8 4.375V7.5H4C1.79375 7.5 0 9.74219 0 12.5V20H22.5125C24.5312 16.9453 27.5812 15 31 15C31.3375 15 31.6688 15.0156 32 15.0547V12.5C32 9.74219 30.2062 7.5 28 7.5H24V4.375C24 1.96094 22.4312 0 20.5 0H11.5C9.56875 0 8 1.96094 8 4.375ZM20 27.5H14C12.8938 27.5 12 26.3828 12 25V22.5H0V32.5C0 35.2578 1.79375 37.5 4 37.5H22.5125C20.9438 35.125 20 32.0703 20 28.75C20 28.3281 20.0125 27.9141 20.0438 27.5H20ZM40 28.75C40 25.7663 39.0518 22.9048 37.364 20.795C35.6761 18.6853 33.3869 17.5 31 17.5C28.6131 17.5 26.3239 18.6853 24.636 20.795C22.9482 22.9048 22 25.7663 22 28.75C22 31.7337 22.9482 34.5952 24.636 36.7049C26.3239 38.8147 28.6131 40 31 40C33.3869 40 35.6761 38.8147 37.364 36.7049C39.0518 34.5952 40 31.7337 40 28.75ZM31 22.5C31.55 22.5 32 23.0625 32 23.75V27.5H34C34.55 27.5 35 28.0625 35 28.75C35 29.4375 34.55 30 34 30H31C30.45 30 30 29.4375 30 28.75V23.75C30 23.0625 30.45 22.5 31 22.5Z",
    fill: "#076AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCase);
export default __webpack_public_path__ + "static/media/business-case.80cf50186d78cc0450b2bdacf373fd76.svg";
export { ForwardRef as ReactComponent };